import {
  AcceptInvitationRequest,
  ConfirmInvitationRequest,
  CreateInvitationRequest,
  DeactivateUserRequest,
  DeleteInvitationRequest,
  GetDeactivatedUsersRequest,
  GetInvitedUsersForLogisticsPartyRequest,
  GetRequestedUserProfileInfoRequest,
  GetUserProfileInfoRequest,
  GetUsersForLogisticsPartyRequest,
  ResendInvitationRequest,
  UpdateUserProfileInfoRequest,
  User,
} from '@amzn/coral_com-amazon-passportusermanagementservice';
import passportUserManagementServiceClient from '../../clients/PassportUserManagementServiceClient';
import envHelper from '../../config/env';
import isSiteExternal from '../../utils/isSiteExternal';

const isExternal = isSiteExternal();

export function getUserProfileInfo() {
  const getUserProfileInfoInput = GetUserProfileInfoRequest.clone({});
  return passportUserManagementServiceClient.getUserProfileInfo(
    getUserProfileInfoInput
  );
}

export function updateUserProfileInfo({
  userIdentifier,
  designation,
  email,
  fullName,
  textPhoneNumber,
  auditVersion,
  defaultLocale,
  monsSelectLocale,
}: User) {
  const user = User.clone({
    userIdentifier,
    designation,
    email,
    fullName,
    textPhoneNumber,
    auditVersion,
    ...(defaultLocale ? { defaultLocale } : {}),
  });
  const updateUserProfileInfoRequest = UpdateUserProfileInfoRequest.clone({
    user,
    ...({ monsSelectLocale } || {}),
  });
  return passportUserManagementServiceClient.updateUserProfileInfo(
    updateUserProfileInfoRequest
  );
}

export function acceptInvitation(request: AcceptInvitationRequest) {
  return passportUserManagementServiceClient.acceptInvitation(request);
}

export function createInvitation({
  invitationChannelInfo,
  locale,
  requestedPermissionsList,
  logisticsPartyId,
}: CreateInvitationRequest) {
  return passportUserManagementServiceClient.createInvitation(
    CreateInvitationRequest.clone({
      invitationChannelInfo,
      locale,
      requestedPermissionsList,
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function resendInvitation({
  invitationId,
  logisticsPartyId,
}: ResendInvitationRequest) {
  return passportUserManagementServiceClient.resendInvitation(
    ResendInvitationRequest.clone({
      invitationId,
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function deleteInvitation({
  invitationId,
  logisticsPartyId,
}: DeleteInvitationRequest) {
  return passportUserManagementServiceClient.deleteInvitation(
    DeleteInvitationRequest.clone({
      invitationId,
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function confirmInvitation({
  invitationId,
  logisticsPartyId,
}: ConfirmInvitationRequest) {
  return passportUserManagementServiceClient.confirmInvitation(
    ConfirmInvitationRequest.clone({
      invitationId,
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function getUsersForLogisticsParty({
  logisticsPartyId,
}: GetUsersForLogisticsPartyRequest) {
  return passportUserManagementServiceClient.getUsersForLogisticsParty(
    GetUsersForLogisticsPartyRequest.clone({
      fetchInternalUsers: !envHelper.isProd(),
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function getInvitedUsersForLogisticsParty({
  logisticsPartyId,
}: GetInvitedUsersForLogisticsPartyRequest) {
  return passportUserManagementServiceClient.getInvitedUsersForLogisticsParty(
    GetInvitedUsersForLogisticsPartyRequest.clone({
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function deactivateUser(deactivateUserRequest: DeactivateUserRequest) {
  return passportUserManagementServiceClient.deactivateUser(
    deactivateUserRequest
  );
}

export function getDeactivatedUsers({
  logisticsPartyId,
}: GetDeactivatedUsersRequest) {
  return passportUserManagementServiceClient.getDeactivatedUsers(
    GetDeactivatedUsersRequest.clone({
      fetchInternalUsers: !envHelper.isProd(),
      ...(!isExternal && logisticsPartyId ? { logisticsPartyId } : {}),
    })
  );
}

export function fetchRequestedUserDetails({
  requestedUserId,
}: GetRequestedUserProfileInfoRequest) {
  return passportUserManagementServiceClient.getRequestedUserProfileInfo(
    GetRequestedUserProfileInfoRequest.clone({
      requestedUserId,
    })
  );
}
